import ReactDOM from "react-dom/client";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { LivePriceProvider } from "./context/LivePriceContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <HashRouter>
      <LivePriceProvider>
        <App />
      </LivePriceProvider>
    </HashRouter>
  </>
);

